import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';
import {
    IPlatformCommandHandler,
    IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CancelWorkFlowCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
    constructor(public commandService: CommandService,
                public router: Router,
                private dialogService: DialogService,
                public fuseSplashScreenService: FuseSplashScreenService,
                public snackBarService: SnackBarService) {
        super(router, commandService, fuseSplashScreenService, snackBarService);
    }

    executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
        const message = null; // 'The current E.A.T. workflow for this record will be removed and you will have to start a new workflow from the beginning.';
        const question = 'Are you sure to cancel the current workflow?';

        this.dialogService.showConfirmDialog('Confirm Cancel Workflow', 'Yes', 'No', message, question).subscribe(res => {
            if (res.action === 'OK') {
                this.executeCommandToApi(command, handler);
            }
        });

        return true;
    }
}
